














import Vue from 'vue';
import { Cell } from '@/models/SmartTable/Cell'; // NOSONAR
import { toDateString } from '@/models/SmartTable/Converters';

export default Vue.extend({
  props: {
    row: Object,
    cell: Object,
    isSelected: { type: Boolean, default: false }
  },
  // @ts-ignore
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cellValue(cell: Cell, row: any): string {
    if (cell.fieldType === 'boolean') {
      if (cell.value === true) {
        return '\u2713';
      } else if (cell.value === false) {
        return '\u2717';
      } else {
        return '';
      }
    } else if (cell.fieldType === 'date') {
      if (cell.value) {
        return toDateString(cell.value);
      } else {
        return cell.value;
      }
    } else if (cell.fieldType === 'datetime-local') {
      return cell.converter(cell.value, row);
    } else if (cell.fieldType === 'dropdown') {
      const dropdownOption = cell.dropdownOptions.find((x) => x.id === cell.value);
      if (dropdownOption) {
        return cell.converter(dropdownOption.title, row);
      } else {
        return '';
      }
    } else {
      return cell.converter(cell.value, row);
    }
  }
});
